<div
  class="color-picker-container"
  (click)="$event.stopPropagation()"
>
  <div
    class="color-sample"
    [style.background-color]="selectedShape.descriptor.fill || '#ccc'"
    [colorPicker]="selectedCellColor"
    (colorPickerChange)="onColorSelected($event)"
    [cpAlphaChannel]="'disabled'"
    [cpSaveClickOutside]="true"
    [cpCloseClickOutside]="true"
    cpPosition="bottom"
    cpPositionOffset="-120%"
    title="Text color"
  ></div>
</div>

<nw-font-family-selector
  [fontFamily]="selectedShape.descriptor.fontFamily || 'Inter'"
  [emitOnly]="true"
  (fontSelected)="onFontFamilySelected($event)"
></nw-font-family-selector>

<!-- Font Weight Toggle -->
<button
  class="font-weight-btn"
  (click)="toggleFontWeight(selectedShape.descriptor.fontWeight)"
  title="Font weight: {{ selectedShape.descriptor.fontWeight || 500 }}"
  [style.font-weight]="selectedShape.descriptor.fontWeight || 500"
>B</button>

<!-- Text Alignment Toggle -->
<button
  class="align-toggle-btn"
  (click)="toggleTextAlign(selectedShape.descriptor.align)"
  title="Text alignment: {{ selectedShape.descriptor.align || 'center' }}"
>
  <nw-icon
    *ngIf="selectedShape.descriptor.align === 'left'"
    type="format_align_left"
    [size]="16"
    color="#666"
  ></nw-icon>
  <nw-icon
    *ngIf="!selectedShape.descriptor.align || selectedShape.descriptor.align === 'center'"
    type="format_align_center"
    [size]="16"
    color="#666"
  ></nw-icon>
  <nw-icon
    *ngIf="selectedShape.descriptor.align === 'right'"
    type="format_align_right"
    [size]="16"
    color="#666"
  ></nw-icon>
</button>

<button
  class="font-selector-close-btn"
  (click)="closed.emit()"
  title="Close"
>
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
</button>
